/**
 * Barrel for the hybrid-synthesis research task contracts (#4653): sibling
 * research task request/result, citations, structured confrontation
 * judgments, the closed failure posture, and the ResearchSynthesisSection V1
 * payload validator.
 *
 * #5666 r4 size-law extraction: moved out of packages/lib/src/index.ts (the
 * public barrel) so a 24-line, single-source-module export group collapses
 * to one `export *` line there instead of growing the file further with each
 * unrelated addition.
 */
export {
  ASK_HELIX_RESEARCH_APPLICABILITY,
  ASK_HELIX_RESEARCH_FAILURE_POSTURES,
  ASK_HELIX_RESEARCH_TASK_SCHEMA_VERSION,
  ASK_HELIX_RESEARCH_TASK_STATUSES,
  isAskHelixResearchCitationDto,
  isAskHelixResearchConfrontationJudgmentDto,
  isResearchSynthesisSectionPropsV1,
} from './ask-helix-research-task';
export type {
  AskHelixResearchApplicabilityDto,
  AskHelixResearchCitationDto,
  AskHelixResearchConfrontationJudgmentDto,
  AskHelixResearchFailurePostureDto,
  AskHelixResearchTaskFailureDto,
  AskHelixResearchTaskRequestDto,
  AskHelixResearchTaskResultDto,
  AskHelixResearchTaskStatusDto,
  AskHelixResearchTaskSuccessDto,
  ResearchSynthesisSectionPropsV1,
} from './ask-helix-research-task';
